// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-waypoint {
  padding: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: auto;
}
.container-waypoint .f-btns {
  padding-left: 12px;
  display: flex;
}
.container-waypoint .f-btns .f-btn {
  margin: 0;
  border: 1px solid var(--app-mid-lighter-2);
  border-radius: 5px;
  --border-radius: 5px;
  --padding-start: 0;
  --padding-end: 0;
  height: auto;
  width: 44px;
  --box-shadow: none;
}
.container-waypoint .f-btns .f-btn .btn-icon {
  font-size: 18px;
}
.container-waypoint .f-btns .f-btn:not(:last-child) {
  margin-right: 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/select-waypoint/select-waypoint.component.scss"],"names":[],"mappings":"AAIA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EAEA,YAAA;AAJF;AAME;EACE,kBAAA;EACA,aAAA;AAJJ;AAMI;EACE,SAAA;EACA,0CAlBU;EAmBV,kBAlBS;EAmBT,oBAAA;EAEA,kBAAA;EACA,gBAAA;EAGA,YAAA;EACA,WAAA;EAGA,kBAAA;AATN;AAYM;EACE,eAAA;AAVR;AAcM;EACE,iBAAA;AAZR","sourcesContent":["\n$borderDivider: 1px solid var(--app-mid-lighter-2);\n$borderRadius: 5px;\n\n.container-waypoint{\n  padding: 1rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n\n  margin: auto;\n\n  .f-btns {\n    padding-left: 12px;\n    display: flex;\n\n    .f-btn {\n      margin: 0;\n      border: $borderDivider;\n      border-radius: $borderRadius;\n      --border-radius: #{$borderRadius};\n      $p: 0;\n      --padding-start: #{$p};\n      --padding-end: #{$p};\n\n\n      height: auto;\n      width: 44px;\n\n\n      --box-shadow: none;\n\n\n      .btn-icon {\n        font-size: 18px;\n      }\n\n\n      &:not(:last-child) {\n        margin-right: 6px;\n      }\n    }\n  }\n\n\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
